export const apiAdminPath = (): string => '/api/site/v1/admin';
